import { useEffect, useState } from "react";
const getScrollTop = () => {
    const [top, setTop] = useState(0);
    useEffect(() => {
        window.addEventListener("scroll", getTop);
        return () => {
            window.removeEventListener("scroll", getTop);
        };
    }, []);
    const getTop = () => {
        setTop(window.pageYOffset);
    };
    return top;
};
export default getScrollTop;
